import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import { useUrlFriendlyToParameters, useNavigateTo } from "helpers/urlFriendly";
import Label from 'components/general/Label';
import { getEventRSC } from 'helpers/rsc';
import { useGetEvents } from 'helpers/commonCodes';
import { FilterEventTypes, createEventData, pagesWithEventFilter, publishFilterEvent } from 'components/common/ocs-custom-events/filterEvents';
import { ALL_URL } from 'helpers/utils';

export default function SelectorEvent({ page = "", eventList, useEventList = false }) {
    const [textCombo, setTextCombo] = useState();
    let params = useUrlFriendlyToParameters();
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)
    //Copy object in order to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   
    const _event = getEventRSC(paramsURL["mirs_rsc"])
    const data = useGetEvents(paramsURL);

    let result = [];
    result = data?.events?.sort((a, b) => a.order - b.order);
    result = result?.filter(event => (event.order !== 0))

    if (paramsURL['mirs_discipline'] !== 'ATH') {
        result = result?.filter(item => item?.phases?.some(phase => Number(phase.order) > 0));
    }


    /*
    result = result?.filter(event => (event.order !== 0))
    result = result?.filter(item => item?.phases?.some(phase => Number(phase.order) > 0));
    */

    let tempOptions = [];
    if (useEventList && Array.isArray(result) && Array.isArray(eventList)) {
        tempOptions = result.filter(r => eventList.includes(r.code))
    } else if (Array.isArray(result)) {
        tempOptions = result;
    }
    const options = tempOptions.map((item, index) => {
        return (
            <Dropdown.Item key={"Selector-Event-" + item.code} eventKey={item.code} >
                {item.longDescription}
            </Dropdown.Item>
        )
    })

    useEffect(() => {
        let lbl = data?.events?.find(item => item.code === paramsURL["mirs_event"] || item.code === _event)?.longDescription
        if (lbl === undefined) { lbl = <Label data={'LabelAllEvents'} /> }
        setTextCombo(lbl);
    }, [data, paramsURL, paramsURL["mirs_event"]]);

    const handleOnChange = (key => {
        paramsURL["mirs_event"] = key
        if (pagesWithEventFilter.includes(page)) {
            const payload = createEventData(FilterEventTypes.EVENT, key);
            publishFilterEvent(payload);
        }
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    })

    const isDisabled = () => {
        return useEventList && !options?.length
    }

    return (
        <Dropdown onSelect={handleOnChange} className={"selectorContainer"} >
            <Dropdown.Toggle variant="success" id="selectorEvent"  disabled={isDisabled()}>
                {textCombo} 
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item key={"Selector-Event-" + ALL_URL.ALL_EVENT} eventKey={ALL_URL.ALL_EVENT} >
                    <Label data={'LabelAllEvents'} />
                </Dropdown.Item>
                {options}
            </Dropdown.Menu>
        </Dropdown>
    );
};



